import { render } from "./BranchPlaceSelect.vue?vue&type=template&id=01dc186d"
import script from "./BranchPlaceSelect.vue?vue&type=script&lang=js"
export * from "./BranchPlaceSelect.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__